import { useId } from 'react'
import IconContainer from '@/components/IconContainer'

export default function IconColorUser(props) {
  const id = useId()
  return (
    <IconContainer
      {...props}
      width="16"
      height="16"
      ariaLabel="User Icon"
      fillRule="evenodd"
      clipRule="evenodd"
    >
      <path
        fill={`url(#${id})`}
        d="M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM14.9787 8C14.9787 4.14576 11.8542 1.02128 7.99999 1.02128C4.14574 1.02128 1.02126 4.14576 1.02126 8C1.02126 9.57461 1.54275 11.0274 2.42245 12.1951C3.02685 10.6577 4.30908 9.51192 5.85732 9.06107C5.18775 8.46854 4.76562 7.60274 4.76562 6.63834C4.76562 4.85223 6.21355 3.4043 7.99967 3.4043C9.78578 3.4043 11.2337 4.85223 11.2337 6.63834C11.2337 7.60167 10.8125 8.46662 10.1443 9.05909C11.6939 9.50811 12.977 10.6529 13.583 12.1878C14.4594 11.0214 14.9787 9.57133 14.9787 8ZM12.7998 13.066L12.7525 12.9079C12.2315 11.1665 10.6654 9.95525 8.86305 9.87643L8.67579 9.87234H8.01514C8.00999 9.87237 8.00483 9.87238 7.99967 9.87238C7.99451 9.87238 7.98935 9.87237 7.98419 9.87234H7.33252C5.53121 9.87234 3.93246 11.0053 3.32807 12.6881L3.26912 12.8641L3.20493 13.0705C4.4553 14.2534 6.14293 14.9787 7.99999 14.9787C9.85942 14.9787 11.549 14.2515 12.7998 13.066ZM8.01229 8.85107C9.22855 8.84427 10.2124 7.8562 10.2124 6.63834C10.2124 5.41626 9.22174 4.42557 7.99966 4.42557C6.77758 4.42557 5.78689 5.41626 5.78689 6.63834C5.78689 7.8562 6.77076 8.84427 7.98703 8.85107H8.01229Z"
      />
      <defs>
        <linearGradient
          id={id}
          x1="16"
          y1="9.28572"
          x2="1.98809e-05"
          y2="9.30335"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2b6aff" />
          <stop offset="1" stopColor="#39d0d8" />
        </linearGradient>
      </defs>
    </IconContainer>
  )
}
